import React, { useEffect, useRef, useLayoutEffect } from 'react';

import { Wrapper } from '@wfp/ui';

import mobileImage from 'assets/mobile-image.png';
import mobile4 from 'assets/mobile4.png';
import mobile5 from 'assets/mobile5.png';

import managedGooglePlayStoreIcon from 'assets/managed_google_play_store_icon.png';
import managedGooglePlayStore from 'assets/managed_google_play_store.png';

import { useLocation, Link } from 'react-router-dom';

import GooglePlayLinkImage from 'assets/google-play.png';
import iOSLinkImage from 'assets/ios.png';
import Step from './Step';

const Mobile = () => {
	const corporatePhoneRef = useRef(null);
	const iOSSectionRef = useRef(null);
	const androidSectionRef = useRef(null);
	const { hash } = useLocation();

	const scrollToCorporatePhone = () =>
		corporatePhoneRef.current.scrollIntoView({
			behavior: 'smooth',
			block: 'start',
		});

	// helper to scroll smoothly to any ref
	const scrollToId = (id) => {
		const element = document.getElementById(id);
		if (element) {
			setTimeout(() => {
				element.scrollIntoView({
					behavior: 'smooth',
					block: 'start',
				});
			}, 200);
		} else {
			console.warn(`Element with id "${id}" not found.`);
		}
	};

	useLayoutEffect(() => {
		console.log(hash);
		if (hash) {
			const cleanHash = hash.replace('#', ''); // remove the "#"
			scrollToId(cleanHash);
		}
	}, [hash]);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<div className="mobile">
			<div className="mobile__header">
				<Wrapper pageWidth="lg" className="mobile__header-inner">
					<div className="mobile__header-main">
						<h1 className="mobile__header-main__title">
							The WFP Dashboard in your pocket
						</h1>
						<p className="mobile__header-main__desc">
							The mobile app of the WFP Dashboard is available for both iOS and
							Android devices.
							<br />
							Please follow the instructions below for iOS or Android devices.
						</p>
						<div className="footer-links footer-links__mobile-apps">
							<Link to="#iOSSection" className="footer-links__image-wrapper">
								<img src={iOSLinkImage} alt="loading" />
							</Link>
							<Link
								to="#androidSection"
								className="google-play-link footer-links__image-wrapper"
							>
								<img src={GooglePlayLinkImage} alt="loading" />
							</Link>
						</div>
					</div>
					<img
						src={mobileImage}
						alt="loading"
						className="mobile__header-image"
					/>
				</Wrapper>
				<hr className="mobile__header-line" />
			</div>
			<Wrapper pageWidth="lg" className="mobile__main">
				<div className="mobile__main-section">
					<h4
						id="iOSSection"
						className="mobile__main-label"
						ref={corporatePhoneRef}
					>
						Install on a corporate and personal iPhone/iPad via Intune Company
						Portal
					</h4>
					<div className="mobile__main-steps">
						<Step
							step={1}
							label="Enroll your device into InTune Company Portal"
							descriptionList={[
								[
									'Check that Microsoft’s',
									{
										text: ' InTune Company Portal ',
										isBold: true,
									},
									'app is installed on your device. If not, download it from ',
									{
										text: 'Apple’s App Store',
										isLink: true,
										href: 'https://apps.apple.com/us/app/intune-company-portal/id719171358',
									},
									'.',
								],
								[
									'If not already enrolled, enroll your device into',
									{
										text: ' InTune Company Portal ',
										isBold: true,
									},
									'by following the ',
									{
										text: 'instructions available here',
										isLink: true,
										href: 'https://newgo.wfp.org/how-do-i/enrol-my-apple-device-intune',
									},
									'.',
								],
							]}
							image={mobile4}
							imageNeedsFill
						/>
						<Step
							step={2}
							label="Open InTune and install the app"
							descriptionList={[
								[
									'Open the',
									{
										text: ' InTune ',
										isBold: true,
									},
									'app.',
								],
								[
									'Select the',
									{
										text: ' “Apps” tab ',
										isBold: true,
									},
									'where you will find apps such as Acrobat reader, Tableau Mobile and WinZip as well as WFP in-house developed apps.',
								],
								[
									'Most recent apps are displayed first. Tap on',
									{
										text: ' “View all Apps” ',
										isBold: true,
									},
									'to view the complete list.',
								],
								[
									'Select',
									{
										text: ' WFP Dashboard ',
										isBold: true,
									},
									'and confirm by tapping on',
									{
										text: ' “Install”.',
										isBold: true,
									},
								],
								[
									'Launch the',
									{
										text: '  WFP Dashboard ',
										isBold: true,
									},
									'app and enjoy it!',
								],
							]}
							image={mobile5}
							imageNeedsFill
						/>
					</div>
					<h4
						id="androidSection"
						className="mobile__main-label"
						ref={corporatePhoneRef}
					>
						Install on a corporate and personal Android via Intune Company
						Portal
					</h4>
					<div className="mobile__main-steps">
						<Step
							step={1}
							label="Verify that the Company Portal application is installed"
							descriptionList={[
								[
									'Check that Microsoft’s',
									{
										text: ' InTune Company Portal ',
										isBold: true,
									},
									'app is installed on your device. If not, download it from ',
									{
										text: 'Google Play Store',
										isLink: true,
										href: 'https://play.google.com/store/apps/details?id=com.microsoft.windowsintune.companyportal',
									},
									'.',
								],
								[
									'If not already enrolled, enroll your device into',
									{
										text: ' InTune Company Portal ',
										isBold: true,
									},
									'by following the ',
									{
										text: 'instructions available here',
										isLink: true,
										href: 'https://newgo.wfp.org/how-do-i/enrol-my-android-device-mdm',
									},
									'.',
								],
							]}
							image={managedGooglePlayStoreIcon}
							imageNeedsFill
						/>
						<Step
							step={2}
							label="Open managed Google Play Store from work profile and install the app"
							descriptionList={[
								[
									'Open the',
									{
										text: ' Google Play Store ',
										isBold: true,
									},
									'app.',
								],
								['Scoll where you will find WFP Dashboard app.'],
								[
									'Select',
									{
										text: ' WFP Dashboard ',
										isBold: true,
									},
									'and confirm by tapping on',
									{
										text: ' “Install”.',
										isBold: true,
									},
								],
								[
									'Launch the',
									{
										text: '  WFP Dashboard ',
										isBold: true,
									},
									'app and enjoy it!',
								],
							]}
							image={managedGooglePlayStore}
							imageNeedsFill
						/>
					</div>
					<div className="mobile__help">
						<h1 className="mobile__help__title">Any help needed?</h1>
						<p className="mobile__help__desc">
							If you are facing any problem in downloading and/or installing the
							app on your devices, please send us an email and we will get back
							to you to support.
						</p>
						<a
							href="mailto:wfp.dashboard@wfp.org"
							className="mobile__help__link"
						>
							Contact us
						</a>
					</div>
				</div>
			</Wrapper>
		</div>
	);
};

export default Mobile;
